<template>
	<el-card class="messagePush clearfloat">
		<!-- 搜索栏 -->
		<el-form
			ref="tableFilter"
			class="filterForm"
			inline
			:model="tableFilter"
		>
			<el-form-item prop="source">
				<el-select
					size="small"
					v-model="tableFilter.source"
					placeholder="审批来源"
					clearable
				>
					<el-option
						v-for="item in $staticData.platforms"
						:key="item.value"
						:value="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="menuName">
				<el-input
					size="small"
					v-model="tableFilter.menuName"
					placeholder="菜谱名称"
					clearable
				>
				</el-input>
			</el-form-item>
			<el-form-item prop="userMenuId">
				<el-input
					size="small"
					v-model="tableFilter.userMenuId"
					placeholder="菜谱ID"
					clearable
				>
				</el-input>
			</el-form-item>
			<el-form-item prop="product">
				<el-input
					size="small"
					v-model="tableFilter.product"
					placeholder="产品类型"
					clearable
				>
				</el-input>
			</el-form-item>
			<el-form-item prop="status">
				<el-select
					size="small"
					v-model="tableFilter.status"
					placeholder="状态"
					clearable
				>
					<el-option
						v-for="item in approveStatus4Sel"
						:key="item.value"
						:value="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="applicantName">
				<el-input
					size="small"
					v-model="tableFilter.applicantName"
					placeholder="申请人"
					clearable
				></el-input>
			</el-form-item>
			<el-form-item>
				<el-date-picker
					v-model.trim="filterDate"
					:picker-options="pickerOptions"
					type="datetimerange"
					size="small"
					start-placeholder="推送开始时间"
					end-placeholder="推送结束时间"
				></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button size="small" @click="handleResetFilter">
					重置
				</el-button>
				<el-button
					type="primary"
					size="small"
					@click="getList('pageNum', 1)"
				>
					搜索
				</el-button>
			</el-form-item>
		</el-form>
		<!-- 表格 -->
		<el-table :data="tableData">
			<el-table-column
				width="50"
				fixed="left"
				label="序号"
				type="index"
			></el-table-column>
			<!-- 审批单号 -->
			<el-table-column
				width="150"
				fixed="left"
				label="审批单号"
				prop="code"
			></el-table-column>
			<!-- 审批来源 -->
			<el-table-column
				label="审批来源"
				width="150"
				prop="source"
				:formatter="
					(row, column, cellValue, index) =>
						$utils.escapePlatforms(cellValue)
				"
			></el-table-column>
			<!-- 状态 -->
			<el-table-column
				label="状态"
				prop="status"
				:formatter="(row) => $utils.escapeApproveStatus(row.status)"
			></el-table-column>
			<!-- 产品 -->
			<el-table-column
				label="产品型号"
				width="80"
				prop="product"
				:formatter="(row) => $utils.escapeNullData(row.product)"
			></el-table-column>
			<!-- 菜谱名称 -->
			<el-table-column
				width="150"
				label="菜谱名称"
				prop="menuName"
				:formatter="(row) => $utils.escapeNullData(row.menuName)"
			></el-table-column>
			<!-- 菜谱ID -->
			<el-table-column
				width="150"
				label="菜谱ID"
				prop="userMenuId"
				:formatter="(row) => $utils.escapeNullData(row.userMenuId)"
			></el-table-column>
			<!-- 申请人 -->
			<el-table-column
				label="申请人"
				prop="applicantName"
				:formatter="(row) => $utils.escapeNullData(row.applicantName)"
			></el-table-column>
			<!-- 审核者 -->
			<el-table-column
				label="审核者"
				prop="reviewerName"
				:formatter="(row) => $utils.escapeNullData(row.reviewerName)"
			></el-table-column>
			<!-- 审核意见 -->
			<el-table-column width="250" label="审核意见" prop="reviewAdvice">
				<template slot-scope="scope">
					<el-tooltip
						effect="dark"
						:content="scope.row.reviewAdvice"
						placement="top-start"
					>
						<span>{{
							$utils.handleDealLongTxt(scope.row.reviewAdvice, 20)
						}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<!-- 发布者 -->
			<el-table-column
				label="发布者"
				prop="publisherName"
				:formatter="(row) => $utils.escapeNullData(row.publisherName)"
			></el-table-column>
			<!-- 发布意见 -->
			<el-table-column width="250" label="发布意见" prop="publishAdvice">
				<template slot-scope="scope">
					<el-tooltip
						effect="dark"
						:content="scope.row.publishAdvice"
						placement="top-start"
					>
						<span>{{
							$utils.handleDealLongTxt(
								scope.row.publishAdvice,
								20
							)
						}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<!-- 拒绝者 -->
			<el-table-column
				label="拒绝者"
				prop="rejectName"
				:formatter="(row) => $utils.escapeNullData(row.rejectName)"
			></el-table-column>
			<!-- 拒绝意见 -->
			<el-table-column width="250" label="拒绝意见" prop="rejectAdvice">
				<template slot-scope="scope">
					<el-tooltip
						effect="dark"
						:content="scope.row.rejectAdvice"
						placement="top-start"
					>
						<span>{{
							$utils.handleDealLongTxt(scope.row.rejectAdvice, 20)
						}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<!-- 申请时间 -->
			<el-table-column
				width="200"
				label="申请时间"
				prop="createTime"
				:formatter="(row) => $utils.formatDate(row.createTime)"
			></el-table-column>
			<!-- 操作 -->
			<el-table-column
				fixed="right"
				width="150"
				:min-width="120"
				label="操作"
			>
				<template slot-scope="scope">
					<el-link
						type="primary"
						size="small"
						v-if="btnPer('com_approvalInfo')"
						class="marginR10"
						@click="handleInfo(scope.row)"
					>
						详情
					</el-link>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination
			class="pagination marginT20"
			align="right"
			@size-change="(pageSize) => getList('pageSize', pageSize, true)"
			@current-change="(page) => getList('pageNum', page)"
			:current-page.sync="tableFilter.pageNum"
			:page-sizes="[10, 20, 30, 40]"
			:page-size.sync="tableFilter.pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total"
		></el-pagination>
		<!-- 详情表单 -->
		<el-dialog title="详情" :visible.sync="dialogVisible" width="60%">
			<!-- 编辑 -->
			<el-form ref="form" label-width="120px">
				<!-- 审批单号 -->
				<el-form-item class="formItem" label="审批单号" prop="code">
					<span>{{ formInfo.code }}</span>
				</el-form-item>
				<!-- 审批来源 -->
				<el-form-item class="formItem" label="审批来源" prop="source">
					<span>{{
						$utils.escapeNullData(formInfo.applicantName)
					}}</span>
				</el-form-item>
				<!-- 申请人 -->
				<el-form-item
					class="formItem"
					label="申请人"
					prop="applicantName"
				>
					<span>{{
						$utils.escapeNullData(formInfo.applicantName)
					}}</span>
				</el-form-item>
				<!-- 状态 -->
				<el-form-item class="formItem" label="状态" prop="status">
					<span>{{
						$utils.escapeApproveStatus(formInfo.status)
					}}</span>
				</el-form-item>
				<!-- 对应机型 -->
				<el-form-item class="formItem" label="对应机型" prop="product">
					<span>{{ $utils.escapeNullData(formInfo.product) }}</span>
				</el-form-item>
				<!-- 菜谱模板 -->
				<el-form-item class="formItem" label="菜谱模板" prop="status">
					<span>{{
						$utils.escapeNullData(formInfo.menuTemplate)
					}}</span>
				</el-form-item>
				<!-- 菜谱ID -->
				<el-form-item class="formItem" label="菜谱ID" prop="status">
					<span>{{
						$utils.escapeNullData(formInfo.userMenuId)
					}}</span>
				</el-form-item>
				<!-- 菜谱名称 -->
				<el-form-item class="formItem" label="菜谱名称" prop="status">
					<span>{{ $utils.escapeNullData(formInfo.menuName) }}</span>
				</el-form-item>
				<!-- 审批状态下 审批意见 -->
				<el-form-item class="block" label="审批意见" prop="status">
					<span>{{
						$utils.escapeNullData(formInfo.reviewAdvice)
					}}</span>
				</el-form-item>
				<!-- 发布状态下 发布意见 -->
				<el-form-item class="block" label="发布意见" prop="status">
					<span>{{
						$utils.escapeNullData(formInfo.publishAdvice)
					}}</span>
				</el-form-item>
				<!-- 拒绝状态下 拒绝意见 -->
				<el-form-item class="block" label="拒绝意见" prop="status">
					<span>{{
						$utils.escapeNullData(formInfo.rejectAdvice)
					}}</span>
				</el-form-item>
				<!-- 查看菜谱 -->
				<el-link
					class="link"
					type="primary"
					@click.native.prevent="goMenu()"
					>查看菜谱</el-link
				>
				<!-- 菜谱审核 -->
				<el-form-item
					v-if="formInfo.status == 2"
					class="block"
					label="菜谱审核"
				>
					<el-input
						type="textarea"
						rows="4"
						v-model="advice"
					></el-input>
				</el-form-item>
				<!-- 菜谱发布 -->
				<el-form-item
					v-if="formInfo.status == 3"
					class="block"
					label="菜谱发布"
				>
					<el-input
						type="textarea"
						rows="4"
						v-model="advice"
					></el-input>
				</el-form-item>
				<!-- 按钮 -->
				<div
					class="clearfloat btnBox"
					v-if="formInfo.status == 2 || formInfo.status == 3"
				>
					<el-button
						class="right marginL20"
						size="small"
						type="primary"
						@click="handleSubmit(true)"
					>
						通过
					</el-button>
					<el-button
						class="right"
						type="danger"
						size="small"
						@click="handleSubmit(false)"
					>
						拒绝
					</el-button>
				</div>
			</el-form>
		</el-dialog>
	</el-card>
</template>

<script>
import { Message } from "element-ui";
export default {
	name: "messagePush",
	data() {
		return {
			dialogVisible: false,
			filterDate: null,
			total: 0,
			act: "",
			approveStatus4Sel: [
				{
					value: "2",
					label: "审批中",
				},
				{
					value: "3",
					label: "发布中",
				},
				{
					value: "4",
					label: "已发布",
				},
				{
					value: "5",
					label: "已拒绝",
				},
			],
			pickerOptions: {
				//只允许选择今天之前的日期(包括今天)
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
			advice: "",
			formInfo: {},
			tableFilter: {
				menuName: null,
				source: null,
				status: null,
				product: null,
				applicantName: null,
				startTime: null,
				endTime: null,
				pageNum: 1,
				pageSize: 10,
			},
			tableData: [],
		};
	},
	watch: {
		filterDate: function (val, oldVal) {
			if (!val) {
				this.tableFilter.startTime = null;
				this.tableFilter.endTime = null;
			} else {
				this.tableFilter.startTime = this.$utils.formatDate(val[0]);
				this.tableFilter.endTime = this.$utils.formatDate(val[1]);
			}
		},
	},
	mounted() {
		if (this.$route.params.id) {
			this.$nextTick(() => {
				let row = {
					id: this.$route.params.id,
				};
				this.handleInfo(row);
			});
		}
		this.getList();
	},
	methods: {
		// 获取表格数据
		getList: function (type, val, isReload = false) {
			isReload ? this.tableFilter.pageNum = 1 : null;
			if (type) {
				this.tableFilter[type] = val;
			}
			this.$http.approves(this.tableFilter).then((res) => {
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
			});
		},
		// 详情
		handleInfo: function (row) {
			let obj = Object.assign({}, row);
			this.$http.approveInfo(obj.id).then((res) => {
				if (res.data.success) {
					this.formInfo = Object.assign(obj, res.data.data);
					this.advice = "";
					this.dialogVisible = true;
					this.act = "info";
				}
			});
		},
		// 提交表单
		handleSubmit: function (flag) {
			let status = null;
			if (flag) {
				status = this.formInfo.status == 2 ? 3 : 4;
			} else {
				status = 5;
			}
			let para = {
				id: this.formInfo.id,
				status: status,
				advice: this.advice,
			};
			this.$http.updataApprove(para).then((res) => {
				this.handleClose();
				this.getList();
			});
		},
		// 关闭表单
		handleClose: function () {
			this.dialogVisible = false;
			this.$refs.form.resetFields();
		},
		// 重置筛选表单
		handleResetFilter: function () {
			this.$refs.tableFilter.resetFields();
			this.filterDate = null;
		},
		// 前往查看菜谱
		goMenu() {
			let obj = Object.assign({}, this.formInfo),
				name = "",
				menuType = obj.menuType,
				perName = "";
			if (obj.menuType == 1) {
				name = obj.status == 4 ? "菜谱清单" : "验证菜谱";
				perName =
					obj.status == 4
						? "cus_checkListMenuOnline"
						: "cus_checkApprovalMenu";
				// 校验是否有对应权限
				if (this.btnPer(perName)) {
					window.open(
						this.$store.state.oldStore.href +
							"/files/newMenu/newMenu.html?id=" +
							obj.menuId + '&from=web'
					);
				} else {
					Message.error("暂无查看权限");
				}
			} else {
				name = obj.status == 4 ? "菜谱清单-标准化" : "验证菜谱-标准化";
				if (obj.status == 4) {
					// 菜谱清单
					if (menuType == 2) {
						// 单锅
						perName = "sta_checkSingleMenu";
					} else {
						// 其他
						perName = "sta_checkOtherMenu";
					}
				} else {
					// 验证菜谱
					if (menuType == 2) {
						// 单锅
						perName = "sta_checkValidationMenu";
					} else {
						// 其他
						perName = "sta_checkValidationOtherMenu";
					}
				}
				// 校验是否有对应权限
				if (this.btnPer(perName)) {
					this.$router.push({
						name: name,
						params: {
							menuId: obj.menuId,
							menuType: menuType,
						},
					});
				} else {
					Message.error("暂无查看权限");
				}
			}
		},
		// ———————————— 获取关联数据 ————————————
		// 判断按钮权限
		btnPer: function (name) {
			let list = this.$store.state.standard.menuNodeList,
				flag = false;
			for (let i in list) {
				if (list[i].href == name) {
					flag = true;
					break;
				}
			}
			return flag;
		},
	},
};
</script>

<style lang='less' scoped>
.filterForm {
	display: inline-block;
	width: 90%;
}
.formItem {
	width: 30%;
	display: inline-block;
	vertical-align: top;
}
.link {
	width: 60px;
	display: block;
}
.btnBox {
	margin-top: 20px;
	margin-bottom: 20px;
}
</style>